import form from './form.ejs'
export default { form }
